import React, { PureComponent } from 'react'
import ReactDOMServer from 'react-dom/server'
import AnimateHeight from 'react-animate-height'
import { reaction } from 'mobx'
import * as R from 'ramda'
import i18n from 'i18next'

import { getQuestionTitle } from '../../../../../utils/QuestionHelper'
import ReportPageTitle from '../ReportPageTitle'
import Panel from '../../../../../UniformComponents/Panel'
import PanelHeader from '../../../../../UniformComponents/PanelHeader'
import DebugInfo from '../DebugInfo'
import { observer } from 'mobx-react'
import AiOverview from './AiOverview'

@observer
class TextQuestion extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            numberOfResponses: R.pathOr(0, [props.dataKey, 'numberOfResponses'])(props.reportStore.reportData.questions),
            responses: [],
            isLoading: false,
            isOpen: false,
        }

        reaction(
            () => props.reportStore.reportDataFetched,
            () => {
                const stateCopy = { ...this.state }
                console.log(JSON.stringify(props.data))
                stateCopy.numberOfResponses = props.reportStore.reportData.questions[props.dataKey].numberOfResponses[0]
                this.setState(stateCopy, () => {
                    this.getReportData()
                })
            },
        )

        props.reportStore.verbatim[props.pageQuestionId] = this.renderPDF
        props.reportStore.questionSorting[props.dataKey] = this.getQuestionSorting
    }

    componentDidMount() {
        this.getReportData()
    }

    componentWillUnmount() {
        const { reportStore, pageQuestionId, dataKey } = this.props
        Reflect.deleteProperty(reportStore.verbatim, pageQuestionId)
        Reflect.deleteProperty(reportStore.questionSorting, dataKey)
    }

    getQuestionSorting = () => {
        const { responses } = this.state
        return [
            Array.from(Array(responses.length).keys()),
            'bar',
            responses.map(({ numberOfResponses }) => numberOfResponses),
            responses.map(({ label }) => label),
        ]
    }

    getReportData = async () => {
        const { question, reportStore } = this.props
        const { isOpen } = this.state
        const { questionTypeCode } = question
        const { appStore } = reportStore
        try {
            const request = JSON.stringify({
                questionId: question.id,
                questionType: questionTypeCode,
                questionOptionId: null,
                filter: {
                    state: reportStore.getReportStates(),
                    surveyDataIds: reportStore.getSurveyDataIdFilter(reportStore.filters.openEnded),
                    ...R.omit(['openEnded'], reportStore.filters),
                },
            })

            const response = await appStore.http.post(`/report/v1/${reportStore.surveyId}/textquestion`, request)

            const responses = R.sortWith([
                R.descend(R.prop('numberOfResponses')),
                R.ascend(R.prop('label')),
            ], response.labels.map((label, index) => ({
                label,
                numberOfResponses: R.pathOr(0, ['numberOfResponses', index], response),
                surveyDataIds: R.pathOr([], ['surveyDataIds', index], response),
            })))

            reportStore.openEnded.set(question.id, responses)

            this.setState({
                numberOfResponses: response.numberOfResponses.reduce((a, b) => a + b, 0),
                responses,
                isLoading: false,
                isOpen,
            })
        } catch (e) {
            console.log(`Error getting getReportData -> ${e}`)
        }
    }

    addVerbatim = (e) => {
        const { reportStore } = this.props
        const { responses } = this.state
        const index = parseInt(e.currentTarget.attributes.getNamedItem('data-index').value, 10)
        reportStore.useVerbatimFilter(responses.surveyDataIds[index], responses.labels[index])
    }

    renderFilter = (label, surveyDataIds) => {
        const { reportStore, question } = this.props
        const { showQuickFilter, filterByOpenEnded, quickFilters } = reportStore
        const hasFilter = quickFilters.has(`${question.id}_${label}`)
        const className = hasFilter
            ? 'fa-regular fa-square-check'
            : 'fa-regular fa-square'

        if (!showQuickFilter) return null

        return (
            <div className="quick-filter-check-container">
                <i
                    onClick={() => filterByOpenEnded(question, label, surveyDataIds)}
                    className={className}
                    style={{ marginRight: '5px' }}
                />
            </div>
        )
    }

    resultRows = () => {
        const { responses } = this.state
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {responses.map(({ label, numberOfResponses, surveyDataIds }, i) => (
                    <div className="textResponse" data-index={i}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {this.renderFilter(label, surveyDataIds)}
                            <span>{label}</span>
                        </div>
                        <span>
                            (
                            {numberOfResponses}
                            )
                        </span>
                    </div>
                ))}
            </div>
        )
    }

    renderPDF = () => (
        ReactDOMServer.renderToStaticMarkup(this.resultRows())
    )

    toggleOpen = () => {
        const stateCopy = { ...this.state }
        stateCopy.isOpen = !stateCopy.isOpen
        this.setState(stateCopy)
    }

    numberOfResponses = () => (
        <div>
            <Panel cssClass="kpi stats">
                <div className="iconCircle">
                    <i className="fa-regular fa-messages" />
                </div>
                <div className="details">
                    <label>Total responses</label>
                    <span>{this.state.numberOfResponses}</span>
                </div>
            </Panel>
        </div>
    )

    render() {
        const { store, reportStore, question } = this.props
        const { isLoading, isOpen } = this.state
        const { survey } = store

        const chevron = isOpen ? 'up' : 'down'

        return (
            <Panel cssClass="question">
                <div id={`questionData_${question.pageQuestionId}`}>
                    <PanelHeader>
                        <div id={`questionTitle_${question.pageQuestionId}`} className="pageTitleContainer">
                            <ReportPageTitle
                                h2={getQuestionTitle({
                                    content: question.content.shortTitle,
                                    locale: reportStore.locale,
                                    defaultLocale: survey.metadata.defaultLocale,
                                    initialLocale: question.metadata.initialLocale,
                                })}
                                h3={getQuestionTitle({
                                    content: question.content.longTitle,
                                    locale: reportStore.locale,
                                    defaultLocale: survey.metadata.defaultLocale,
                                    initialLocale: question.metadata.initialLocale,
                                })}
                                reportStore={reportStore}
                                questionTypeCode={question.questionTypeCode}
                            />
                            {this.numberOfResponses()}
                        </div>
                    </PanelHeader>
                    <DebugInfo
                        store={store}
                        questionTypeCode={question.questionTypeCode}
                        reportStore={reportStore}
                        questionId={question.id}
                        pageQuestionId={question.pageQuestionId}
                    />
                    {question.questionTypeCode === 'DT' && <AiOverview />}
                    <div
                        onClick={this.toggleOpen}
                        style={{
                            padding: '15px 25px',
                            color: '#8B99A7',
                            fontWeight: '600',
                            cursor: 'pointer',
                            background: 'rgb(250, 251, 252)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                        }}
                    >
                        {i18n.t('report_question_responses')}
                        <div
                            style={{
                                padding: '2px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: '1px solid #8B99A7',
                                borderRadius: '4px',
                                fontSize: '12px',
                            }}
                        >
                            <i className={`fa-light fa-chevron-${chevron}`} />
                        </div>
                    </div>
                    {isLoading && <div className="loader" />}
                    {!isLoading && isOpen && (
                        <AnimateHeight
                            duration={250}
                            height={(isOpen ? 'auto' : 0)}
                            style={{
                                padding: '25px',
                            }}
                        >
                            {this.resultRows()}
                        </AnimateHeight>
                    )}
                </div>
            </Panel>
        )
    }
}

export default TextQuestion
